<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">{{title}}</h1>

      <v-layout row class="my-4 mx-0">
        <v-flex xs12>
          <v-btn
              class="warning ma-0"
              @click="triggerUpload"
              :loading="uploading"
              :disabled="uploading"
          >
            Загрузить фото
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <input
              ref="fileInput"
              type="file"
              style="display: none;"
              accept="image/*"
              @change="onFileChange"
          >
        </v-flex>
      </v-layout>

      <v-layout row class="my-4 mx-0">
        <v-flex xs12 lg8 md8>
          <img :src="avatarSrc" height="150" v-if="avatarSrc">
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-layout row>
            <v-flex xs6 lg6 md6>
              <v-select
                  :items="userGroupTitleList"
                  label="Группа"
                  v-model="userGroup"
                  @input="onUserGroupSelect()"
                  outline
                  class="mr-3"
                  no-data-text="Нет данных"
              ></v-select>
            </v-flex>
            <v-flex xs6 lg6 md6>
              <v-select
                  :items="branchTitleList"
                  label="Филиал"
                  v-model="branch"
                  @input="onBranchSelect()"
                  outline
                  class="mr-3"
                  no-data-text="Нет данных"
              ></v-select>
            </v-flex>

            <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null && branch !== ''">
              <v-select
                :items="filialTitleList"
                label="Направление"
                v-model="filial"
                class="mr-3"
                @input="onFilialSelect()"
                outline
                no-data-text="Нет данных"
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs4 lg4 md4>
              <v-text-field
                  label="Фамилия"
                  v-model="surname"
                  :rules="textInputRules"
                  validate-on-blur
                  outline
                  class="mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 lg4 md4>
              <v-text-field
                  label="Имя"
                  v-model="firstName"
                  :rules="textInputRules"
                  validate-on-blur
                  outline
                  class="mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 lg4 md4>
              <v-text-field
                  label="Отчество"
                  v-model="patronymic"
                  outline
                  class="mr-3"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6 lg6 md6>
              <v-text-field
                  label="Телефон"
                  v-model="phone"
                  :rules="textInputRules"
                  mask="+7 (###) ###-##-##"
                  validate-on-blur
                  outline
                  class="mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 lg6 md6>
              <v-text-field
                  label="E-mail"
                  v-model="email"
                  outline
                  class="mr-3"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <p class="title">Торговые точки</p>
      <v-layout row v-if="pointTreeData.length > 0 || pointListTreeDataSingle.length > 0" class="mb-4">
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <div v-if="id === null">
            <v-text-field
                label="Поиск"
                v-model="pointSearch"
                outline
            ></v-text-field>
            <v-progress-circular
                v-if="pointLoading"
                :size="50"
                color="primary"
                indeterminate
            ></v-progress-circular>
            <div v-if="pointSearchTree.length > 0 && !pointLoading">
              <tree
                  :data="pointSearchTree"
                  :options="{
                  checkbox: false,
                  fetchData(node) {
                    if (node.children.length > 0) {
                      return blank()
                    } else {
                      return getPointFolder(node.data.id)
                    }
                  },
                  treeType: 'pointTree'
                }"
                  class="tree--small"
              >
                <span class="tree-text body-2 ma-0 py-0 px-0" slot-scope="{ node }">
                  <template v-if="node.data.type === 'folder'">
                    {{node.data.text}}
                  </template>
                  <template v-if="node.data.type === 'point'">
                    <v-checkbox
                        :label="node.data.text"
                        class="ma-0 pa-0 user-tree-checkbox body-2"
                        @change="onPointChanged(node)"
                        :input-value="isChecked(node)"
                    ></v-checkbox>
                  </template>
                </span>
              </tree>
            </div>
            <div v-else>
              <div v-if="pointTreeData.length > 0 && !pointLoading">
                <tree
                    :data="pointTreeData"
                    :options="{
                  checkbox: false,
                  fetchData(node) {
                    if (node.children.length > 0) {
                      return blank()
                    } else {
                      return getPointFolder(node.data.id)
                    }
                  },
                  treeType: 'pointTree'
                }"
                    class="tree--small"
                >
                <span class="tree-text body-2 ma-0 py-0 px-0" slot-scope="{ node }">
                  <template v-if="node.data.type === 'folder'">
                    {{node.data.text}}
                  </template>
                  <template v-if="node.data.type === 'point'">
                    <v-checkbox
                        :label="node.data.text"
                        class="ma-0 pa-0 user-tree-checkbox body-2"
                        @change="onPointChanged(node)"
                        :input-value="isChecked(node)"
                    ></v-checkbox>
                  </template>
                </span>
                </tree>
              </div>
            </div>
          </div>
          <div v-else-if="id !== null">
            <v-btn
                color="primary"
                @click="pointDialog = true"
            >
              Изменить
            </v-btn>
            <div v-if="pointListTreeDataSingle.length > 0">
              <tree
                  :options="{
                  checkbox: true
                }"
                  :data="pointListTreeDataSingle"
                  class="tree--small tree-single-page"
              />
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-dialog
          v-model="pointDialog"
          max-width="800"
      >
        <div v-if="pointDialog">
          <v-layout row>
            <v-flex xs12 lg12 md12 pa-3 class="elevation-1 white">
              <p class="title">Торговые точки</p>
              <v-text-field
                  label="Поиск"
                  v-model="pointSearch"
                  outline
              ></v-text-field>
              <v-progress-circular
                  v-if="pointLoading"
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
              <div v-if="pointSearchTree.length > 0 && !pointLoading">
                <tree
                    :data="pointSearchTree"
                    :options="{
                      checkbox: false,
                      fetchData(node) {
                        if (node.children.length > 0) {
                          return blank()
                        } else {
                          return getPointFolder(node.data.id)
                        }
                      },
                      treeType: 'pointTree'
                    }"
                    class="tree--small"
                >
                    <span class="tree-text body-2 ma-0 py-0 px-0" slot-scope="{ node }">
                      <template v-if="node.data.type === 'folder'">
                        {{node.data.text}}
                      </template>
                      <template v-if="node.data.type === 'point'">
                        <v-checkbox
                            :label="node.data.text"
                            class="ma-0 pa-0 user-tree-checkbox body-2"
                            @change="onPointChanged(node)"
                            :input-value="isChecked(node)"
                        ></v-checkbox>
                      </template>
                    </span>
                </tree>
              </div>
              <div v-else>
                <div v-if="pointTreeData.length > 0 && !pointLoading">
                  <tree
                      :data="pointTreeData"
                      :options="{
                      checkbox: false,
                      fetchData(node) {
                        if (node.children.length > 0) {
                          return blank()
                        } else {
                          return getPointFolder(node.data.id)
                        }
                      },
                      treeType: 'pointTree'
                    }"
                      class="tree--small"
                  >
                    <span class="tree-text body-2 ma-0 py-0 px-0" slot-scope="{ node }">
                      <template v-if="node.data.type === 'folder'">
                        {{node.data.text}}
                      </template>
                      <template v-if="node.data.type === 'point'">
                        <v-checkbox
                            :label="node.data.text"
                            class="ma-0 pa-0 user-tree-checkbox body-2"
                            @change="onPointChanged(node)"
                            :input-value="isChecked(node)"
                        ></v-checkbox>
                      </template>
                    </span>
                  </tree>
                </div>
              </div>
              <v-btn
                  color="primary"
                  @click="pointDialog = false"
              >
                Сохранить
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-dialog>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading && !uploading"
              :disabled="!valid || loading || uploading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickCreateUser"
          >
            {{id === null ? 'Создать' : 'Сохранить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Пользователи', link: '/users/active'}
      ],
      pageDataReady: {
        isReady: false,
        userList: false,
        userGroupList: false,
        branchList: false,
        points: false
      },
      id: null,
      title: 'Новый пользователь',
      firstName: null,
      surname: null,
      patronymic: null,
      phone: null,
      email: null,
      avatarSrc: '',
      avatarId: null,
      avatarRes: null,
      uploading: false,
      userGroup: null,
      userGroupId: null,
      branch: null,
      branchId: null,
      filial: null,
      filialId: null,
      valid: false,

      pointListTreeData: [],
      pointIdList: [],
      pointTreeData: [],
      pointTreeIdCounter: 0,
      pointLoading: false,
      pointDialog: false,
      pointListTreeDataSingle: [],
      pointSearch: '',
      pointSearchTimer: null,
      pointSearchTree: [],

      textInputRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.userGroupList) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }
        if (!this.pageDataReady.points) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onPointChanged (node) {
        let position = this.pointIdList.indexOf(node.data.id)
        if (~position) {
          this.pointIdList.splice(position, 1)
        } else {
          this.pointIdList.push(node.data.id)
        }
      },
      isChecked (node) {
        return ~this.pointIdList.indexOf(node.data.id)
      },
      checkValidate () {
        if (this.firstName === null || this.firstName === '') {
          this.valid = false
        } else if (this.surname === null || this.surname === '') {
          this.valid = false
        } else if (this.phone === null || this.phone === '') {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      async onClickCreateUser () {
        let userData = {
          id: this.id,
          firstName: this.firstName,
          surname: this.surname,
          phone: this.phone,
          userGroupId: this.userGroupId
        }

        if (this.patronymic !== null || this.patronymic !== '') {
          userData.patronymic = this.patronymic
        }
        if (this.email !== null || this.email !== '') {
          userData.email = this.email
        }
        if (this.avatarId !== null && typeof this.avatarId !== 'undefined') {
          userData.avatarId = this.avatarId
        } else {
          userData.avatarId = 0
        }

        if (this.pointIdList.length > 0) {
          userData.pointIdList = this.pointIdList
        }

        if (this.branchId !== null) {
          userData.branchId = this.branchId
        }

        if (this.filialId !== null) {
          userData.filialId = this.filialId
        }

        await this.$store.dispatch('createUser', userData)
          .then((data) => {
            if (typeof data.user !== 'undefined') {
              this.$router.push('/users/single/' + data.user.id)
            }
          })
          .catch(() => {})
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== undefined && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
          this.$store.dispatch('getFilialList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
      },
      onFilialSelect () {
        if (this.filial !== null && this.filial !== 'Все направления') {
          for (let i = 0; i < this.filialList.length; i++) {
            if (this.filialList[i].title === this.filial) {
              this.filialId = this.filialList[i].id
              break
            }
          }
        } else {
          this.filialId = null
        }
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.firstName = null
        this.surname = null
        this.patronymic = null
        this.phone = '+7'
        this.email = null
        this.avatarSrc = ''
        this.avatarId = null
        this.avatarRes = null
        this.userGroup = null
        this.userGroupId = null
        this.branch = null
        this.branchId = null
        this.pointListTreeData = []
        this.pointFolderIdList = []
        this.pointIdList = []
        this.pointTreeData = []
        this.pointTreeIdCounter = 0
        this.pointSearch = ''
        this.pointSearchTimer = null
        this.pointSearchTree = []
        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Пользователи', link: '/users/active'}
        ]

        if (this.$router.currentRoute.path.indexOf('/users/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать пользователя'
          this.$store.dispatch('getUserSingle', {id: this.id})
          this.breadcrumbs.push({name: 'Редактировать пользователя'})

          this.getPointFolder(0)
            .then((data) => {
              this.pointTreeData = data
              this.pageDataReady.points = true
              this.pageDataStatus()
            })
            .catch(() => {})
        } else {
          this.id = null
          this.title = 'Новый пользователь'
          this.breadcrumbs.push({name: 'Новый пользователь'})

          this.getPointFolder(0)
            .then((data) => {
              this.pointTreeData = data
              this.pageDataReady.points = true
              this.pageDataStatus()
            })
            .catch(() => {})
        }

        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getUserGroupList')
          .then(() => {
            this.pageDataReady.userGroupList = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getBranchList')
          .then(() => {
            this.pageDataReady.branchList = true
            this.pageDataStatus()
          })
      },
      async getPointFolder (nodeId) {
        let folder
        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: 'active'})
          .then((data) => {
            if (this.id !== null && this.user !== null) {
              folder = this.pointTreeDataStructure([data], false, this.user.point_folder_tree)[0].children
            } else {
              folder = this.pointTreeDataStructure([data])[0].children
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      },
      isChildrenInPointTree (id, tree) {
        if (tree !== null && typeof tree !== 'undefined') {
          for (let i = 0; i < tree.length; i++) {
            let isId = tree[i].id === id
            let isFolders = typeof tree[i].point_folder_list !== 'undefined' ? tree[i].point_folder_list.length > 0 : false
            let isPoints = typeof tree[i].point_list !== 'undefined' ? tree[i].point_list.length > 0 : false

            if (isId && (isFolders || isPoints)) {
              return true
            } else if (isFolders) {
              if (this.isChildrenInPointTree(id, tree[i].point_folder_list)) {
                return true
              }
            }
          }
        }
        return false
      },
      pointTreeDataStructure (pointFolderList, folderChecked = false, indeterminateTree = null) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          resultList[i] = {}

          if (typeof pointFolderList[i].title !== 'undefined') {
            resultList[i].text = pointFolderList[i].title
          }

          if (typeof pointFolderList[i].id !== 'undefined') {
            resultList[i].data = {
              id: pointFolderList[i].id,
              type: 'folder'
            }
            resultList[i].id = this.pointTreeIdCounter++
            resultList[i].isBatch = pointFolderList[i].have_children
          }

          let folderIdPosition = this.pointFolderIdList.indexOf(pointFolderList[i].id)
          let currentFolderChecked = false
          if (~folderIdPosition || folderChecked) {
            currentFolderChecked = true
          }
          resultList[i].state = { checked: currentFolderChecked }

          if (!currentFolderChecked && indeterminateTree !== null) {
            // resultList[i].state.indeterminate = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
            // resultList[i].state.expanded = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            resultList[i].children = []
            resultList[i].children = this.pointTreeDataStructure(pointFolderList[i].point_folder_list, folderChecked, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            if (typeof resultList[i].children === 'undefined') {
              resultList[i].children = []
            }

            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              let index = resultList[i].children.length
              resultList[i].children[index] = {
                text: pointFolderList[i].point_list[j].title,
                data: {
                  id: pointFolderList[i].point_list[j].id,
                  type: 'point'
                }
              }
            }
          }
        }
        return resultList
      },
      pointTreeDataSingleStructure (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeDataSingleStructure(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      },
      pointListByPointFolderList (pointFolderList) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            let list = this.pointListByPointFolderList(pointFolderList[i].point_folder_list)
            resultList = resultList.concat(list)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              resultList.push(pointFolderList[i].point_list[j].id)
            }
          }
        }
        return resultList
      },
      async pointTreeLoader (id = 0) {
        this.pointLoading = true
        let pointTreeData = await this.$store.dispatch('getPointFolderList', {id: id, mode: 'active'})
          .then((data) => {
            return data
          })
          .catch((e) => {
            console.log(e)
          })

        if (typeof pointTreeData.point_folder_list !== 'undefined') {
          for (let i = 0; i < pointTreeData.point_folder_list.length; i++) {
            if (this.isChildrenInPointTree(pointTreeData.point_folder_list[i].id, this.user.point_folder_tree)) {
              let child = await this.pointTreeLoader(pointTreeData.point_folder_list[i].id)
              pointTreeData.point_folder_list[i].point_folder_list = child.point_folder_list
              pointTreeData.point_folder_list[i].point_list = child.point_list
            }
          }
        }

        if (id === 0) {
          this.pointTreeData = this.pointTreeDataStructure([pointTreeData], false, this.user.point_folder_tree)[0].children
          this.pointLoading = false
          this.pageDataReady.points = true
          this.pageDataStatus()
        } else {
          return pointTreeData
        }
      },
      triggerUpload () {
        this.$refs.fileInput.click()
      },
      onFileChange (event) {
        this.avatarRes = event.target.files[0]
        this.uploading = true
        this.$store.dispatch('uploadPhoto', {photo: this.avatarRes})
          .then((data) => {})
          .catch(() => {
            this.uploading = false
          })
      },
      onUserGroupSelect () {
        if (this.userGroup !== null) {
          for (let i = 0; i < this.userGroupList.length; i++) {
            if (this.userGroupList[i].title === this.userGroup) {
              this.userGroupId = this.userGroupList[i].id
              break
            }
          }
        }
      },
      async blank () {
        return []
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      user () {
        return this.$store.getters.userSingle
      },
      photo () {
        return this.$store.getters.photo
      },
      userGroupList () {
        return this.$store.getters.userGroupList
      },
      userGroupTitleList () {
        return this.$store.getters.userGroupTitleList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      filialTitleList () {
        return this.$store.getters.filialTitleList
      },
      filialList () {
        return this.$store.getters.filialList
      },
      pointTree () {
        return this.$store.getters.pointTree
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      user (newUser, oldUser) {
        if (this.user !== null && this.user !== undefined) {
          this.firstName = this.user.first_name
          this.surname = this.user.surname
          this.patronymic = this.user.patronymic
          this.phone = this.user.phone
          this.email = this.user.email
          this.avatarId = this.user.photo.id
          this.avatarSrc = this.user.photo.url_resized
          this.userGroup = this.user.user_group ? this.user.user_group.title : ''
          this.userGroupId = this.user.user_group.id !== null ? this.user.user_group.id : null
          this.branch = this.user.branch !== null ? this.user.branch.title : ''
          this.branchId = this.user.branch !== null ? this.user.branch.id : null

          if (this.branch) {
            this.$store.dispatch('getFilialList', {branchId: this.branchId})
          }

          if (typeof this.user.point_folder_tree !== 'undefined' && this.user.point_folder_tree !== null) {
            this.pointIdList = this.pointListByPointFolderList(this.user.point_folder_tree)
            this.pointListTreeDataSingle = this.pointTreeDataSingleStructure(this.user.point_folder_tree)
          }

          // this.pointTreeLoader()
        }
      },
      photo (newPhoto, oldPhoto) {
        this.avatarSrc = this.photo.url_resized
        this.avatarId = this.photo.id
        this.uploading = false
      },
      userGroupList (val) {
        if (this.userGroupList.length > 0 && this.id === null) {
          this.userGroup = this.userGroupList[0].title
          this.userGroupId = this.userGroupList[0].id
        }
      },
      filialList () {
        if (this.user.filial_id !== null && this.filialId === null) {
          const currentFilial = this.filialList.find(item => item.id === parseInt(this.user.filial_id))

          if (currentFilial) {
            this.filial = currentFilial.title
            this.filialId = currentFilial.id
          }
        }
      },
      pointSearch (val) {
        if (this.pointSearchTimer !== null) {
          clearTimeout(this.pointSearchTimer)
        }

        this.pointLoading = true
        let _this = this
        if (this.pointSearch.length >= 5) {
          this.pointSearchTimer = setTimeout(function () {
            _this.$store.dispatch('getPointTree', {q: _this.pointSearch})
          }, 1000)
        } else {
          this.pointSearchTimer = setTimeout(function () {
            this.pointLoading = false
            _this.$store.commit('setPointTree', [])
          }, 1000)
        }
      },
      pointTree (val) {
        this.pointLoading = false
        this.pointSearchTree = this.pointTreeDataStructure(this.pointTree)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/UserNew.vue